export const testimonials = {
  title: "O que dizem as famílias",
  subtitle: "Testemunhos da nossa comunidade educativa",
  items: [
    {
      quote: "Gándara combina os princípios Montessori com flexibilidade, respeito e alegria. Os nossos filhos sentem-se felizes, seguros e curiosos todos os dias, e enfrentamos o futuro com total tranquilidade.",
      author: "Alba & Marc",
      role: "Família Gándara"
    },
    {
      quote: "Procurávamos uma escola Montessori, internacional e onde as nossas filhas fossem felizes. Na Gándara encontrámos tudo isso e muito mais.",
      author: "Patri & Pablo",
      role: "Família Gándara"
    },
    {
      quote: "Gándara é um lugar seguro onde as crianças crescem respeitadas e acompanhadas. A equipa docente é sensível e compreende verdadeiramente cada criança.",
      author: "Marie",
      role: "Família Gándara"
    }
  ]
};
